import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const PROGRAMME_LABELS = {
  presentation: "Presentation",
  executive_presence: "Executive Presence",
};

export default function WorkspaceSelector({ workspaces, viewerRole }) {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-paper px-6 py-16" data-testid="workspace-selector">
      <div className="max-w-3xl mx-auto">
        <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-3">InterAct Globally</p>
        <h1 className="font-serif text-3xl text-ink mb-2">Choose a Workspace</h1>
        <p className="font-body text-ink-soft mb-10">You hold more than one active workspace — pick where to go.</p>

        <div className="grid gap-4 sm:grid-cols-2">
          {workspaces.map((w) => (
            <Card
              key={w.wrk_id}
              role="button"
              tabIndex={0}
              className="border border-ink/15 hover:border-terracotta transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-terracotta"
              data-testid={`workspace-card-${w.wrk_id}`}
              onClick={() => navigate(`/rehearsal-room/w/${w.wrk_id}/home`)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/rehearsal-room/w/${w.wrk_id}/home`);
                }
              }}
            >
              <CardContent className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <Badge variant="outline" className="uppercase text-xs tracking-wide">
                    {PROGRAMME_LABELS[w.programme_type] || w.programme_type}
                  </Badge>
                  <span className="text-xs uppercase text-ink-soft">{w.access_type}</span>
                </div>
                <h2 className="font-serif text-xl text-ink mb-1">{w.title}</h2>
                {viewerRole === "coach" ? (
                  <p className="text-sm text-ink-soft mb-4" data-testid={`workspace-card-coach-label-${w.wrk_id}`}>Workspace coach: You</p>
                ) : (
                  w.coach_display_name && (
                    <p className="text-sm text-ink-soft mb-4" data-testid={`workspace-card-coach-label-${w.wrk_id}`}>Coach: {w.coach_display_name}</p>
                  )
                )}
                <span className="text-sm font-medium text-terracotta">
                  {w.next_action_label || "Enter Workspace"} →
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
